import { ApplicationUserResponse } from "@api/apiClient";
import { useUserPermissions } from "@api/users";
import i18n from "@i18n/i18n";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";

export interface PermissionsFormProps {
  user: ApplicationUserResponse | null;
  open: boolean;
  onClose: () => void;
}

const PermissionsForm = observer((props: PermissionsFormProps) => {
  console.log("PermissionsForm", props);
  const [permissions, setPermissions] = useState<string[]>([]);
  const userPermissions = useUserPermissions(props.user?.userId, { enabled: !!props.user });

  useEffect(() => {
    const newPermissions = userPermissions.data?.filter((x) => x.type === "permission").map((x) => x.value!) || [];
    setPermissions(newPermissions);
  }, [userPermissions.data]);

  return (
    <Drawer anchor="right" open={props.open} onClose={props.onClose}>
      <Card variant="outlined" sx={{ width: "550px", height: "100%", overflow: "auto" }}>
        <CardContent>
          <Box>
            <Stack spacing={1}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                <Typography variant="h5">{i18n.t("users-tab.permissions-form.title")}</Typography>
                <IconButton onClick={props.onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Box component={"pre"}>{JSON.stringify(props.user, null, 2)}</Box>
              <Box component={"pre"}>{JSON.stringify(permissions, null, 2)}</Box>
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Drawer>
  );
});

export default PermissionsForm;
